export const environment = {
  production: true,
  environment: 'production', // 'dev', 'staging', or 'production'
  restrictToDevOrGod: false,
  version: '2026-02-02-1120', // Update this string after every major deploy
  firebase: {
    apiKey: 'AIzaSyD-wflCHtUMkG9Xp2xIa2vYOd7mF63OTAA',
    authDomain: 'cannonball-ops.firebaseapp.com',
    projectId: 'cannonball-ops',
    storageBucket: 'cannonball-ops.appspot.com',
    messagingSenderId: '905812214181',
    appId: '1:905812214181:web:956e05dacb02433c9ea84c',
    databaseURL: 'https://cannonball-ops-default-rtdb.firebaseio.com',
  },
  // Base URL for backend Cloud Run functions in production
  functionsUrl: 'https://api-kty6efpneq-uc.a.run.app',
};
